import { toGoLangInvoke } from "../common/windowFunctions";
import { logStatus } from "../utils";
export class StorageClientImpl {
    constructor(gluePromise, asyncConstructors, loggerClient) {
        this.gluePromise = gluePromise;
        this.asyncConstructors = asyncConstructors;
        this.loggerClient = loggerClient;
        const pw = this.asyncConstructors.addConstructor();
        gluePromise.then((g) => {
            this.glue = g;
            this.asyncConstructors.finishConstructor(pw);
        });
    }
    logStatus(method, type, data) {
        logStatus(this.loggerClient, this.glue, {
            api: "StorageClient",
            method, type, data
        });
    }
    async clearCache(cb, params) {
        this.logStatus("clearCache", "start", params);
        await this.asyncConstructors.ready();
        const { err } = await toGoLangInvoke(() => this.glue.interop.invoke("FSBL.Clients.StorageClient.clearCache", {
            ...params
        }), cb);
        if (err) {
            this.logStatus("remove", "error", err);
        }
        this.logStatus("clearCache", "return");
        return { err };
    }
    async remove(params, cb) {
        this.logStatus("remove", "start", params);
        await this.asyncConstructors.ready();
        const { err } = await toGoLangInvoke(() => this.glue.interop.invoke("FSBL.Clients.StorageClient.remove", params), cb);
        if (err) {
            this.logStatus("remove", "error", err);
        }
        this.logStatus("remove", "return");
        return { err };
    }
    async keys(params, cb) {
        this.logStatus("keys", "start", params);
        await this.asyncConstructors.ready();
        const { err, data } = await toGoLangInvoke(() => this.glue.interop.invoke("FSBL.Clients.StorageClient.keys", params), cb);
        if (err) {
            this.logStatus("keys", "error", err);
        }
        this.logStatus("keys", "return", data);
        return { err, data };
    }
    async getStandardized(params, cb) {
        this.logStatus("getStandardized", "start", params);
        await this.asyncConstructors.ready();
        const { err, data } = await toGoLangInvoke(() => this.glue.interop.invoke("FSBL.Clients.StorageClient.get", params), cb);
        if (err) {
            this.logStatus("getStandardized", "error", err);
        }
        this.logStatus("getStandardized", "return", data);
        return { err, data };
    }
    async getMultiple(params, cb) {
        this.logStatus("getMultiple", "deprecated", "Not Implemented");
        return {
            err: "get multiple is not implemented"
        };
    }
    async save(params, cb) {
        this.logStatus("save", "start", params);
        await this.asyncConstructors.ready();
        const { err } = await toGoLangInvoke(() => this.glue.interop.invoke("FSBL.Clients.StorageClient.save", {
            key: params.key ?? params.field,
            value: params.value,
            topic: params.topic
        }), cb);
        if (err) {
            this.logStatus("save", "error", err);
        }
        this.logStatus("save", "return");
        return { err };
    }
    async setUser(params, cb) {
        this.logStatus("setUser", "start", params);
        await this.asyncConstructors.ready();
        const { err } = await toGoLangInvoke(() => this.glue.interop.invoke("FSBL.Clients.StorageClient.setUser", params), cb);
        if (err) {
            this.logStatus("setUser", "error", err);
        }
        this.logStatus("setUser", "return");
        return { err };
    }
    async get(params, cb) {
        this.logStatus("get", "start", params);
        const result = await this.getStandardized(params, cb);
        this.logStatus("get", "return", result);
        return result.data;
    }
}
